/**
 * @file        src/pages/CorporateDashboard.jsx
 * @description Corporate Dashboard — the same KPIs / revenue chart / today's
 *              status / recent ledger as the B2C Dashboard (Dashboard.jsx),
 *              fixed to audience=b2b, instead of forking the page.
 * @author      Kinetika Labs
 * @created     2026-09-15
 * @changelog
 *   - 2026-09-15 Claude — Initial. Splits the single Dashboard (which had a
 *                          Customer-type segment whose only real effect was on
 *                          the revenue chart) into two audience-separated
 *                          screens, matching every other B2C/Corporate pair in
 *                          this console.
 */
import Dashboard from './Dashboard';

export default function CorporateDashboard() {
  return <Dashboard title="Corporate Dashboard" audience="b2b" />;
}
